import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { AvForm, AvGroup, AvInput, AvFeedback } from 'availity-mobx-reactstrap-validation';
import { FormGroup } from 'reactstrap';

import AppUser from 'js/stores/AppUser';
import FormState from 'js/stores/forms/LoginSignupDialogForm';
import analytics from 'js/services/Analytics';

import Button from 'js/components/common/Button';
import ErrorDisplay from 'js/components/common/ErrorDisplay';
import ForgotPasswordLink from './ForgotPasswordLink';
import AppState from "js/stores/AppState";
import { EyeOpenIcon, LockIcon } from '../../../core/Icons/Eye'

const noop = () => true;

@observer
export default class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }
  formState = FormState.create();

  togglePasswordVisibility = () => {
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  after = (response) => {

    const mseller = AppState.currentPage === 'MSellerPage';
    const checkout = AppState.currentPage === 'CheckoutPage';

    analytics.identify(response);

    analytics
      .track(mseller ? 'SP_mseller_logged_in' : checkout ? 'SP_create_link_pickup_logged_in' : 'Logged In', {
        'Email': AppUser.email,
        'Signup Method': 'Manual',
        'Name': this.props.page ? this.props.page.full_name : '',
        'Address': this.props.page ? this.props.page.address : '',
        'Position': AppState.currentPage.indexOf('LandingPage') !== -1 ? 'landing' : window.location.href,
        'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
          ? 'seller' : 'buyer'
      });

    analytics.track('CTA_Engaged_User', {
      'Email': AppUser.email,
      'Signup/Login Method': 'Manual',
      'Date': new Date().toString(),
      'Position': AppState.currentPage.indexOf('LandingPage') !== -1 ? 'landing' : window.location.href,
      'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
        ? 'seller' : 'buyer'
    })
    return (this.props.after || noop)(AppUser.email);
  };

  formSubmitted = (event, errors, formValues) => {
    this.formState.clearError();
    const predicate = this.props.predicate || noop;

    if (predicate() && !errors.length && !this.formState.requestInProgress) {
      (this.props.before || noop)();
      this.formState.setIsRequesting();
      this.formValues = formValues;

      AppUser.loginUser(null, formValues)
        .then(this.after)
        .catch(error => {
          this.formState.setIsRequesting(false);
          if (error.response && error.response.data && error.response.data.message) {
            this.formState.setError(error.response.data.message);
          } else {
            this.formState.setError('Invalid credentials');
          }
        });
    }
  };

  render() {
    const { showPassword } = this.state;
    const { error, requestInProgress, showForgotPassword } = this.formState;
    return (
      <AvForm onSubmit={this.formSubmitted}>
        <AvGroup>
          <AvInput name="email" placeholder="Enter your email" required validate={{ email: true }} autoComplete='email'/>
          <AvFeedback>Please enter your email address.</AvFeedback>
        </AvGroup>
        <AvGroup style={{ position: 'relative' }}> {/* Container for input and icon */}
          <AvInput
            type={showPassword ? 'text' : 'password'}
            name="password"
            placeholder="Enter your password"
            maxLength={72}
            required
            autoComplete='password'
          />

          <AvFeedback>Please enter your password.</AvFeedback>
          <div style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', cursor: 'pointer' }}>
            {showPassword
              ? <LockIcon onClick={this.togglePasswordVisibility} />
              : <EyeOpenIcon onClick={this.togglePasswordVisibility} />}
          </div>
        </AvGroup>

        <AvGroup>
          {this.props.token && (
            <AvInput type="hidden" name="single_use_token" value={this.props.token} />
          )}
          {this.props.mseller && (
            <AvInput type="hidden" name="mseller" value={this.props.mseller} />
          )}
        </AvGroup>

        {this.props.showForgotPassword && <ForgotPasswordLink />}

        <FormGroup>
          <Button type="submit" isLoading={requestInProgress} inverted>
            {this.props.submitLabel || 'Log In'}
          </Button>
        </FormGroup>

        <ErrorDisplay>{error}</ErrorDisplay>
      </AvForm>
    );
  }
}
